import BaseHttpService from "JS/services/BaseHttpService";
import { IAccountAppointmentSearchResult } from "../types/appointment";
import { IBaseHttpService } from "JS/types/Http";

export interface IAccountAppointmentService {
	searchAppointments(): Promise<IAccountAppointmentSearchResult>;
}

const BASE_URL = "/account/appointments";
export default class AccountAppointmentService implements IAccountAppointmentService {
	constructor(private _httpService: IBaseHttpService = new BaseHttpService()) {}

	searchAppointments(): Promise<IAccountAppointmentSearchResult> {
		return this._httpService.get<IAccountAppointmentSearchResult>(`${BASE_URL}/search`);
	}

}